import { render, staticRenderFns } from "./classroomDetail.vue?vue&type=template&id=f0893f18&scoped=true&"
import script from "./classroomDetail.vue?vue&type=script&lang=js&"
export * from "./classroomDetail.vue?vue&type=script&lang=js&"
import style0 from "./classroomDetail.vue?vue&type=style&index=0&id=f0893f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0893f18",
  null
  
)

export default component.exports